import React from "react";
import fieldPropTypes from "./field-prop-types";

const IconField = ({ field, components: { Icon } }) => (
  <Icon
    src={field.src}
    alt={field.alt}
    showIcon={field.showIcon}
    stylesObject={field.stylesObject}
  />
);

IconField.propTypes = fieldPropTypes;

export default IconField;
